import { fetchAllPages } from '@core/api/pagination';
import { request } from '@core/api';
import { organizationManagementClientApiV1 as organizationManagementClientApi } from '@deepup/apis';
import { OrderNumber } from '@projects/types/orderNumbers';
import { getTransport } from '../transport';

type OrderNumbersOpts = {
  isTelekomProject: boolean | undefined;
  projectId: string | undefined;
  elementId: string | undefined;
};

export type AssetTypes = 'SCAN' | 'PHOTO' | 'POINT_ELEMENT' | 'SPLINE_ELEMENT';

type AssetsResponse = {
  scanIds?: string[];
  photoIds?: string[];
  pointElementIds?: string[];
  splineElementIds?: string[];
};

export const getPointElementOrderNumbers = async ({
  isTelekomProject,
  projectId,
  elementId,
}: OrderNumbersOpts) => {
  if (!(isTelekomProject && projectId && elementId)) {
    return { data: [] };
  }

  const res = await request('GET', {
    path: ['projects', projectId, 'pointElements', elementId, 'orderNumbers'],
  });
  const orderNumbers = (res ?? []) as OrderNumber[];

  return { data: orderNumbers };
};

export const getSplineElementOrderNumbers = async ({
  isTelekomProject,
  projectId,
  elementId,
}: OrderNumbersOpts) => {
  if (!(isTelekomProject && projectId && elementId)) {
    return { data: [] };
  }

  const res = await request('GET', {
    path: ['projects', projectId, 'splineElements', elementId, 'orderNumbers'],
  });
  const orderNumbers = (res ?? []) as OrderNumber[];

  return { data: orderNumbers };
};

export const getAssetsBySma = async ({
  isTelekomProject,
  projectId,
  orderNumber,
  assetTypes,
}: {
  projectId: string | undefined;
  orderNumber: string | undefined;
  isTelekomProject: boolean;
  assetTypes: AssetTypes[];
}) => {
  if (!isTelekomProject || !projectId || !orderNumber) {
    return { data: undefined };
  }

  const res = await request('POST', {
    path: ['projects', projectId, 'assets'],
    body: { orderNumber, assetTypes },
  });

  return { data: res as AssetsResponse };
};

export const getOrderNumbers = async ({ projectId }: { projectId: string | undefined }) => {
  if (!projectId) {
    return { data: [] };
  }

  const transport = getTransport();
  const client = new organizationManagementClientApi.OrganizationManagementServiceClient(transport);

  const { data: items } = await fetchAllPages({
    fetchFunction: ({ options }) => {
      return client.listOrderNumbers({
        projectId,
        orderNumber: '',
        orderNumberLike: '',
        closed: 0,
        options,
      }).response;
    },
  });

  return { data: items || [] };
};
